<script>
  /**@type {import ('$lib/types/index').MediaQueryImages}*/
  export let mediaQueryImages;

  /**@type {boolean}*/
  export let isContain = false;
  /**@type {string}*/
  export let object = "center center";
  /**@type {number}*/
  export let radius = 0;
  /**@type {string}*/
  export let alt = '';

</script>

<picture>
  <source srcset={mediaQueryImages.img} media="(max-width: 420px)" />
  <source srcset={mediaQueryImages.img2x} media="(max-width: 920px)" />
  <img loading="lazy" decoding="async"
    style={`object-position: ${object}; border-radius: ${radius}px`}
    class:contain={isContain}
    src={mediaQueryImages?.img3x}
    alt={alt}
  />
</picture>

<style>
  picture {
    display: flex;
    width: 100%;
    height: 100%;
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  .contain {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
</style>
